import config from 'config';
import axios from 'axios';
import FileSaver from 'file-saver';

const ROOT = config.API_BASE_URL;

class ChecklistReportService {
    static getRoot() {
        return ROOT;
    }

    static getChecklistPhotoReportOptions() {
        return new Promise((resolve, reject) => {
            axios
                .get(`${ROOT}reports/photo-corrective-actions-report-options`)
                .then((data) => {
                    resolve({ data: data.data, response: data });
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    static getChecklistPhotoReport(groupingId, checklistId, checklistTaskId, startDate, endDate) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${ROOT}reports/photo-corrective-actions-report?groupingId=${groupingId}&checklistId=${checklistId}&checklistTaskId=${checklistTaskId}&startDate=${startDate}&endDate=${endDate}`)
                .then((data) => {
                    resolve({ data: data.data, response: data });
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    static getChecklistDataDownload(downloadType, startDate, endDate, checklistTagId, checklistTagName) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${ROOT}reports/checklist-data-download?downloadType=${downloadType}&startDate=${startDate}&endDate=${endDate}&checklistTagId=${checklistTagId}`)
                .then((response) => {
                    const blob = new Blob([response.data], { type: "application/csv" });
                    FileSaver.saveAs(blob, `${downloadType}-${checklistTagName.replaceAll(' ', '-').toLowerCase()}-report.csv`);
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    static getChecklistScheduleAdherenceReport(groupingId, startDate, endDate, startVariance, endVariance) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${ROOT}reports/checklist-schedule-adherence-report?groupingId=${groupingId}&startDate=${startDate}&endDate=${endDate}&startVariance=${startVariance}&endVariance=${endVariance}`)
                .then((data) => {
                    resolve({ data: data.data, response: data });
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    static getChecklistComplianceReportOptions() {
        return new Promise((resolve, reject) => {
            axios
                .get(`${ROOT}reports/checklist-compliance-report-options`)
                .then((data) => {
                    resolve({ data: data.data, response: data });
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    static getChecklistComplianceReport(groupingId, startDate, endDate, tagId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${ROOT}reports/checklist-compliance-report?groupingId=${groupingId}&startDate=${startDate}&endDate=${endDate}&tagId=${tagId}`)
                .then((data) => {
                    resolve({ data: data.data, response: data });
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
}

export default ChecklistReportService;
